import type {
  brandQuerySchema,
  categoryQuerySchema,
  productQuerySchema,
  productReviewQuerySchema,
} from "@spare-cart/contracts/catalog";
import type { z } from "@spare-cart/contracts/common";
import type { wishlistQuerySchema } from "@spare-cart/contracts/customers";

export const catalogKeys = {
  all: ["catalog"] as const,
  products: () => [...catalogKeys.all, "products"] as const,
  productsList: (query: z.input<typeof productQuerySchema>) =>
    [...catalogKeys.products(), "list", query] as const,
  product: (id: string) => [...catalogKeys.products(), id] as const,
  categories: () => [...catalogKeys.all, "categories"] as const,
  categoriesList: (query: z.input<typeof categoryQuerySchema>) =>
    [...catalogKeys.categories(), "list", query] as const,
  brands: () => [...catalogKeys.all, "brands"] as const,
  brandsList: (query: z.input<typeof brandQuerySchema>) =>
    [...catalogKeys.brands(), "list", query] as const,
  wishlist: () => [...catalogKeys.all, "wishlist"] as const,
  wishlistList: (query: z.input<typeof wishlistQuerySchema>) =>
    [...catalogKeys.wishlist(), "list", query] as const,
  reviews: () => [...catalogKeys.all, "reviews"] as const,
  reviewsList: (query: z.input<typeof productReviewQuerySchema>) =>
    [...catalogKeys.reviews(), "list", query] as const,
  reviewEligibility: (productId: string) =>
    [...catalogKeys.reviews(), "eligibility", productId] as const,
  visualSearch: (imageUrl: string) => [...catalogKeys.all, "visual-search", imageUrl] as const,
  banners: () => [...catalogKeys.all, "banners"] as const,
};
